function updateMargin() {
    const emElement = document.querySelector(".collection-title-text-section__top-content h2 em");
    const targetElement = document.querySelector(".collection-title-text-section__bottom-content");

    if (window.innerWidth > 576 && emElement && targetElement) {
        const emWidth = emElement.offsetWidth;
        targetElement.style.marginLeft = emWidth + "px";
    } else if (targetElement) {
        targetElement.style.marginLeft = "";
    }
}

document.addEventListener("DOMContentLoaded", updateMargin);
window.addEventListener("resize", updateMargin);
